import styled from 'styled-components';

import { fadeIn } from 'utils/style/animations';

import { ISideButtonWrappedProps, Sizes } from './types';

export const Container = styled.div<{ isMobile: boolean }>`
  width: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  ${p =>
    p.isMobile &&
    `width: calc(100% + 2rem);
    margin: 0 -1rem;`}
`;

export const CardContainerWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: ${p => (p.isMobile ? 'auto' : 'hidden')};
  margin-bottom: 20px;
`;

export const CardWrapper = styled.span`
  display: flex;
  justify-content: center;
  margin: 0 8px;
`;
export const CardsWrapper = styled.div<{ $offset: number }>`
  display: flex;
  transform: translateX(-${p => p.$offset}px);
  transition: all 1s;
  padding: 20px 0px;
`;

export const CardContainer = styled.div<{
  isMobile: boolean;
  $innerPadding: number;
  $isMaxWidth: boolean;
}>`
  ${p => (p.isMobile ? 'display: flex; padding: 20px 1rem; overflow: auto' : 'overflow: hidden')};
  height: 100%;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }
  margin: 0px
    ${p => (p.isMobile ? '0rem' : `calc(${p.$innerPadding}px - ${p.$isMaxWidth ? '0px' : '1rem'})`)};
`;

export const ScrollerWrapper = styled.div<{ isMobile: boolean; hide: boolean }>`
  display: ${p => (p.isMobile && !p.hide ? 'flex' : 'none')};
  overflow: auto;
  width: 60%;
  height: 6px;
  background: ${Styles.color.grey.eight};
  margin: 0 auto;
  border-radius: 999rem;
`;

export const Scroller = styled.div<{
  widthPercent: number;
  scrollLeft: number;
  scrollWidth: number;
}>`
  width: ${p => p.widthPercent}%;
  margin-left: ${p => Math.floor((p.scrollLeft / p.scrollWidth) * 100)}%;
  border-radius: 999rem;
  background: ${Styles.color.grey.one};
`;

const SideButtonWrapped = styled.div<ISideButtonWrappedProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px;
  z-index: ${Styles.zIndex.overlay};
  display: flex;
  align-items: center;
  transition: 0.3s;
  ${p => (p.isMobile ? `opacity: ${p.isOverflow ? 1 : 0};` : '')};
`;

export const RightButtonWrapper = styled(SideButtonWrapped)`
  right: ${p => (p.isMobile ? 0 : '4px')};
  justify-content: flex-end;
`;

export const LeftButtonWrapper = styled(SideButtonWrapped)`
  left: ${p => (p.isMobile ? 0 : '4px')};
  justify-content: flex-start;
`;

const CarouselButton = styled.button`
  min-width: 42px;
  min-height: 42px;
  border-radius: 50%;
  background-color: ${Styles.color.primary};
  color: ${Styles.color.white};
  border: none;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.3rem;
  animation: 0.15s ${fadeIn};
  transition: 0.15s;
`;

export const RightCarouselButton = styled(CarouselButton)`
  > svg {
    padding-left: 2px;
  }
`;

export const LeftCarouselButton = styled(CarouselButton)`
  > svg {
    padding-right: 2px;
  }
`;

export const Spacer = styled.span`
  min-width: ${Sizes.SPACER}px;
`;
